import { RiMenu2Fill } from "react-icons/ri";
import { GoHome } from "react-icons/go";
import { PiRanking } from "react-icons/pi";
import { BsPeople } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";


import {AnimatePresence, motion} from 'motion/react'

import logo from '../../assets/imagens/logo_ACB.png'

import './Menu.css'
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
export default function Menu ({menuOpen, setMenu}){
    const navigate = useNavigate()

    const {logout} = useAuth()

    return (
        <AnimatePresence>
            {menuOpen && <motion.div
            className="menuAberto"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
        >
            <div className="areaLogo">
                <img src={logo} />
                <button onClick={()=>setMenu(!menuOpen)} className="btnMenu">
                     <RiMenu2Fill color="#fff" size={30} />
                </button>
            </div>
            <motion.div
                className="flex"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                whileHover={{
                    borderLeft:'5px solid var(--azul-claro)',
                    backgroundColor:"var(--background-transparent)",
                    transition:{ease:'easeInOut'}
                }}
                 onClick={()=>navigate('/Inicial')}
            >
                <GoHome color="#fff" size={15}/>
                <button className="rota">
                    Inicio
                </button>
            </motion.div>

            <motion.div
                className="flex"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                whileHover={{
                    borderLeft:'5px solid var(--azul-claro)',
                    backgroundColor:"var(--background-transparent)"
                }}
                onClick={()=>navigate('/ranking')}
            >
                <PiRanking color="#fff" size={15}/>
                <button  className="rota">
                    Ranking
                </button>
            </motion.div>

            <motion.div
                className="flex"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
                whileHover={{
                    borderLeft:'5px solid var(--azul-claro)',
                    backgroundColor:"var(--background-transparent)"
                }}
                onClick={()=>navigate('/equipe-ti')}
            >
               <BsPeople color="#fff" size={15}/>
                <button  className="rota">
                    Conheça nossa equipe
                </button>
            </motion.div>

            <motion.div
                className="flex"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
                whileHover={{
                    borderLeft:'5px solid var(--azul-claro)',
                    backgroundColor:"var(--background-transparent)"
                }}
                onClick={()=>logout()}
            >
               <BiLogOut color="#fff" size={15} />
                <button  className="rota" onClick={()=>logout()}>
                    Sair
                </button>
            </motion.div>

        </motion.div>}
        </AnimatePresence>
    )
}